import icon1 from "../../assets/images/consalticon1.svg"
import icon2 from "../../assets/images/consalticon2.svg"
import icon3 from "../../assets/images/consalticon3.svg";
import icon4 from "../../assets/images/consalticon4.svg";
import icon5 from "../../assets/images/consalticon5.svg";
import { motion } from 'motion/react';

type ConsaltancyType = {
  icon: string;
  title: string;
  text: string;
}
const consaltancies: ConsaltancyType[] = [
  {
    icon: icon1,
    title: "Boost Financial Performance: ",
    text: "Drive sustainable growth with strategic financial planning and analysis that optimizes your bottom line.",
  },
  {
    icon: icon2,
    title: "Maximize Value Through M&A: ",
    text: "Leverage expert mergers and acquisitions to expand your business and increase profitability.",
  },
  {
    icon: icon3,
    title: "Enhance Operational Efficiency: ",
    text: "Streamline processes to reduce costs and increase operational effectiveness.",
  },
  {
    icon: icon4,
    title: "Navigate Complex Regulations: ",
    text: "Stay compliant with up-to-date financial strategies that align with industry regulations.",
  },
  {
    icon: icon5,
    title: "Access Expert Financial Guidance: ",
    text: "Benefit from comprehensive financial planning, forecasting, and analysis to make smarter business decisions.",
  },
];

const Consaltancy = () => {
  return (
    <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-10 sm:py-28">
      <div className="flex flex-col justify-center sm:items-center">
        <div className="relative mb-9">
          <motion.h3
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="poppins-regular text-primary z-20 relative"
          >
             CONSULTANCY SERVICE
          </motion.h3>
          <div className="size-16 bg-[#E7E9FF] rounded-full absolute -top-5 -left-5"></div>
        </div>
        <motion.h2
          initial={{ y: -100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-4xl sm:text-5xl montserrat-regular text-secondary sm:text-center mb-6"
        >
          <span className="montserrat-semibold">Consultancy</span> Services For
          A <br /> Stronger{" "}
          <span className="montserrat-semibold">Medical Industry</span>
        </motion.h2>
        <motion.p
          initial={{ y: -100, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 1 }}
          viewport={{ once: true }}
          className="montserrat-regular text-secondary sm:text-center mb-6"
        >
          With extensive CFO experience, I help organizations thrive by
          delivering strategic financial guidance that drives growth and ensures
          operational excellence. Specializing in the healthcare and finance
          sectors, I focus on fostering long-term success through collaboration
          and innovation. Let’s achieve more together!
        </motion.p>
      </div>
      <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-3">
        {consaltancies.map((item) => (
          <div
            key={item.title}
            className=" border border-primary rounded-lg group cursor-pointer"
          >
            <div className="group-hover:bg-primary py-9 px-10 h-full rounded-lg transition-all duration-300">
              {" "}
              <img
                src={item.icon}
                alt=""
                className="mb-8 group-hover:-translate-y-6 group-hover:opacity-0 transition-all duration-500 size-16"
              />
              <h3 className="text-secondary montserrat-semibold text-2xl mb-6 group-hover:text-white group-hover:-translate-y-6 transition-all duration-500">
                {item.title}
              </h3>
              <p className="montserrat-regular text-secondary group-hover:-translate-y-6 group-hover:text-white transition-all duration-500">
                {item.text}
              </p>
              {/* <div className="opacity-0 flex group-hover:opacity-100 gap-4 group-hover:-translate-y-6 transition-all duration-500 mt-6 montserrat-semibold text-white cursor-pointer">
                Read More <img src={arrow} />
              </div> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Consaltancy